import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IOpenForm } from "./MyTeamLead";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Filter, IFilter } from "./Filter";
import { Tag } from "primereact/tag";
import { LeadHistory } from "./History";
import { Itinerary } from "../myLead/Itinerary";
import { Search } from "../../shared/Search";
import { TransferHistory } from "../myLead/TransferHistory";
import { TransferLead } from "./TransferLead";
import { showDateTime } from "../../utilities/helper";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false, status: [] } as { data: ILead[], count: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [filter, setFilter] = useState<IFilter>({});
    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'updatedAt',
        sortOrder: -1
    });
    const [selectedLeads, setSelectedLeads] = useState<ILead[]>([]);
    const [historyModal, setHistoryModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [genLead, setGenLead] = useState(false);
    const [transferHistory, setTransferHistory] = useState({ open: false, singleData: {} } as IOpenForm);

    const hideGenLeadDialog = () => {
        setGenLead(false);
    };


    const hideTransferHistory = () => {
        setTransferHistory({
            open: false,
            singleData: {}
        });
    };

    const hideHistoryDialog = () => {
        setHistoryModal({ singleData: {}, open: false })
    };
    const showHistoryDialog = (rowData: ILead) => {
        setHistoryModal({ singleData: rowData, open: true })
    };

    const [itineraryModel, setItineraryModel] = useState({ singleData: {}, open: false } as IOpenForm);
    const hideItineraryDialog = () => {
        setItineraryModel({ singleData: {}, open: false })
    };
    const showItineraryDialog = (rowData: ILead) => {
        setItineraryModel({ singleData: rowData, open: true });
    }

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("MyTeamLead", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(filter)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { leads: ILead[], count: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.leads, count: data.count, status: data.status, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: { statusId: 5 } });
    };

    const openEdit = (rowDatauser: ILead) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const RemoveLead = async (rowData: ILead) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`MyTeamLead/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Lead Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: ILead) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.contactName}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveLead(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>My Team Lead</h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("MyTeamLead", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );

    const leadFromTemplate = (rowData: ILead) => {
        return (<>
            {rowData.pocId !== undefined && rowData.pocId > 0 &&
                <span>{rowData.pocName}</span>}
            {rowData.userId !== undefined && rowData.userId > 0 &&
                <span>{rowData.userName}</span>}
        </>
        );
    };

    const actionBodyTemplate = (rowData: ILead) => {
        return (
            <div>
                {/* {props.hasPermission("Lead", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />} */}
                {props.hasPermission("MyTeamLead", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} ></Button>}
                {props.hasPermission("MyTeamLead", "History") && <Button icon="pi pi-history" className='p-button-info p-button-text p-0' onClick={() => { showHistoryDialog(rowData) }} ></Button>}
                {
                    <Button
                        icon="pi pi-box"
                        className="p-button-help p-button-text p-0"
                        tooltip="Transfer History"
                        onClick={() =>
                            setTransferHistory({
                                open: true,
                                singleData: rowData
                            })
                        }
                    />
                }
                {/* {rowData.hasRequirement && props.hasPermission("MyTeamLead", "Requirement") && <Button icon="pi pi-calculator" className='p-button-info p-button-text p-0' onClick={() => { showItineraryDialog(rowData) }} ></Button>} */}
            </div>
        );
    };


    const addressBody = (rowData: ILead) => {
        return (
            rowData.cityName ?
                <span>{rowData.cityName}, {rowData.stateName}, {rowData.countryName}</span> :
                <span>{rowData.stateName}, {rowData.countryName}</span>
        );
    }

    const statusBody = (rowData: ILead) => {
        return (
            <Tag severity={rowData.isLeadActive ? 'success' : 'danger'} value={rowData.statusName} rounded></Tag>
        );
    }

    return (
        <>
            <div className="flex align-items-center justify-content-start gap-2 p-2">
                <Tag className="cursor-pointer" onClick={() => setFilter((prev) => ({ ...prev, statusId: undefined }))} severity={filter.statusId === 0 || filter.statusId === undefined || filter.statusId === null ? 'warning' : 'info'} value={`All: ${tableData.count}`} rounded></Tag>
                {tableData.status.map((s) => {
                    return (
                        <Tag className="cursor-pointer" key={s.id} onClick={() => setFilter((prev) => ({ ...prev, statusId: s.id }))} severity={filter.statusId === s.id ? 'warning' : 'info'} value={`${s.name}: ${s.count}`} rounded></Tag>
                    )
                })}
                {selectedLeads.length > 0 && (
                    <Button
                        label="Reassign Lead"
                        icon="pi pi-plus"
                        className="p-button-sm p-button-rounded p-button-success"
                        onClick={() => setGenLead(true)}
                    />
                )}
            </div>
            <Filter toast={props.toast} header={"Filter"} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                selectionMode="checkbox"
                selection={selectedLeads}
                onSelectionChange={(e) => setSelectedLeads(e.value)}
            >
                <Column selectionMode="multiple" />
                <Column field="contactName" header="Customer" />
                <Column field="contactContact" header="Contact" />
                <Column field="alternativePhone" header="A.Contact" />
                <Column field="contactEmail" header="Email" />
                <Column field="alternativeEmail" header="A.Email" />
                <Column field="contactWhatsapp" header="Whatsapp" />
                <Column field="address" header="Address" body={addressBody} />
                <Column field="sourceName" header="Source" sortable />
                <Column field="" header="LeadFrom" body={leadFromTemplate} />
                <Column field="assignedToName" header="AssignedTo" />
                <Column field="statusName" header="Status" sortable body={statusBody} />
                <Column field="createdBy" header="Assigned By" />
                <Column field="createdAt" header="Assigned At" sortable body={(row) =>
                                        row.createdAt
                                            ? showDateTime(row.createdAt)
                                            : "-"
                                    } />
                <Column field="updatedBy" header="Updated By" />
                <Column field="updatedAt" header="Updated At" sortable body={(row) =>
                                        row.updatedAt
                                            ? showDateTime(row.updatedAt)
                                            : "-"
                                    } />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <TransferLead
                onSuccess={() => {
                    loadTableData();
                    setSelectedLeads([]);
                }}
                open={genLead}
                hideDialog={hideGenLeadDialog}
                contacts={selectedLeads}
                toast={props.toast}
            />
            <TransferHistory
                singleData={transferHistory.singleData}
                open={transferHistory.open}
                hideDialog={hideTransferHistory}
                toast={props.toast}
                reloadData={loadTableData}
                hasPermission={props.hasPermission}
            />
            {props.hasPermission("MyTeamLead", "History") && <LeadHistory hasPermission={props.hasPermission} singleData={historyModal.singleData} open={historyModal.open} hideDialog={hideHistoryDialog} toast={props.toast}></LeadHistory>}
            {/* {props.hasPermission("Lead", "Requirement") && <Itinerary toast={props.toast} singleData={itineraryModel.singleData} open={itineraryModel.open} hideDialog={hideItineraryDialog} ></Itinerary>} */}
            <ConfirmDialog />
        </>
    );
}
